import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { kiosksBrowserMapStateToProps } from "mapToProps/kioskManager";
import * as kioskActions from "actions/kiosks";
import RaisedButton from "material-ui/RaisedButton";
import HeaderContainer from "modules/ContentContainer/HeaderContainer";
import Sidebar from "modules/Sidebar/Sidebar";
import _map from "lodash/map";
import ContentContainer from "modules/ContentContainer";
import { TableGrid, Dialog } from "@terraincognita/ui-core";
import { Helmet } from "react-helmet";
import AddKioskDialog from "./AddKioskDialog";
import "./KiosksBrowser.scss";

const gridHeader = {
        1: {
          id: 1,
          label: "Kiosk Name",
        },
        2: {
          id: 2,
          label: "Connection Status",
        },
        3: {
          id: 3,
          label: "Last Published",
        },
        4: {
          id: 4,
          label: "",
        },
      }
class KiosksBrowser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: [],
      addKioskDialogOpen: false,
    };
    this._kiosksPollInterval = null;
    this.navigateToKiosk = this.navigateToKiosk.bind(this);
    this.openAddKioskDialog = this.openAddKioskDialog.bind(this);
    this.closeAddKioskDialog = this.closeAddKioskDialog.bind(this);
    this.startUptimePolling = this.startUptimePolling.bind(this);
    this.stopUptimePolling = this.stopUptimePolling.bind(this);
  }

  componentDidMount() {
    this.props.requestKiosks();
    this.props.requestKioskAppVersions();
    this.startUptimePolling();
  }

  componentWillUnmount() {
    this.stopUptimePolling();
  }

  startUptimePolling() {
    // Stop any existing polling first to avoid multiple intervals
    this.stopUptimePolling();

    // Set up polling to fetch kiosks every 8 seconds
    this._kiosksPollInterval = setInterval(() => {
      this.props.requestKiosks();
    }, 8000);
  }

  stopUptimePolling() {
    if (this._kiosksPollInterval) {
      clearInterval(this._kiosksPollInterval);
      this._kiosksPollInterval = null;
    }
  }

  navigateToKiosk(kioskID) {
    this.props.goToKiosk(kioskID);
  }

  openAddKioskDialog() {
    this.setState({ addKioskDialogOpen: true });
  }

  closeAddKioskDialog() {
    this.setState({ addKioskDialogOpen: false });
  }

  render() {
    const { sidebarProps, sidebarMode } = this.props;

    const headerStyle = {
      backgroundColor: "#f2f2f2",
    };

    return (
      <div className="kiosks-browser">
        <Helmet>
          <title>Kiosks</title>
        </Helmet>
        <HeaderContainer
          alignRight
          // selectMode={this.props.selectMode}
          title="Kiosks"
          history={this.props.history}
          confirmNavigation={this.props.confirmNavigation}
          goBackAction={this.props.goBackAction}
          closeAction={this.props.closeAction}
          handleCloseClicked={this.props.handleCloseClicked}
          theme={this.props.headerTheme}
          actions={this.props.headerActions}
          mode={this.props.headerMode}
          tabs={this.props.headerTabs}
        />
        <Sidebar {...sidebarProps}>
          <div className="kiosks-browser-sidebar">
            Use the <b>Storycrafter Kiosk</b> app to present a project on your touchscreen display.
          </div>
          <div>
            <RaisedButton
              label="Add a Kiosk"
              primary
              onTouchTap={this.openAddKioskDialog}
            />
          </div>
        </Sidebar>
        <ContentContainer
          backgroundColor="white"
          className="content-container"
          sidebarMode={sidebarMode}
        >
          {this.props.kiosks ? (
            <TableGrid
              items={this.props.kiosks}
              header={this.props.header || gridHeader}
              idNode="id"
              headerStyle={headerStyle}
              viewAction={this.navigateToKiosk}
              sortable
            />
          ) : null}
        </ContentContainer>
        <AddKioskDialog
          open={this.state.addKioskDialogOpen}
          onClose={this.closeAddKioskDialog}
        />
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return kiosksBrowserMapStateToProps(state, ownProps);
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  const { slugBase } = stateProps;
  return Object.assign({}, stateProps, {
    requestKiosks: () => dispatchProps.kiosksFetchRequest(),
    requestKioskAppVersions: () => dispatchProps.kioskAppVersionsFetchRequest(),
    goToKiosk: (kioskID) => {
      ownProps.history.push(`${slugBase}/${kioskID}`);
    }
  });
}

KiosksBrowser.defaultProps = {
  kiosks: null,
  header: null,
  confirmNavigation: null,
  goBackAction: null,
  closeAction: null,
  handleCloseClicked: null,
  headerTheme: null,
  headerActions: null,
  headerMode: null,
  headerTabs: null,
};

KiosksBrowser.propTypes = {
  kiosks: PropTypes.oneOfType([
    PropTypes.objectOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        columns: PropTypes.objectOf(
          PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            label: PropTypes.string,
          }),
        ),
      }),
    ),
    PropTypes.arrayOf(PropTypes.object),
  ]),
  requestKiosks: PropTypes.func.isRequired,
  goToKiosk: PropTypes.func.isRequired,
  sidebarProps: PropTypes.shape({
    title: PropTypes.string,
    goBackAction: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  }).isRequired,
  sidebarMode: PropTypes.string.isRequired,
  header: PropTypes.objectOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
    }),
  ),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  confirmNavigation: PropTypes.func,
  goBackAction: PropTypes.func,
  closeAction: PropTypes.func,
  handleCloseClicked: PropTypes.func,
  headerTheme: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  headerActions: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.any), PropTypes.shape({})]),
  headerMode: PropTypes.string,
  headerTabs: PropTypes.arrayOf(PropTypes.any),
};

export default connect(mapStateToProps, kioskActions, mergeProps)(KiosksBrowser);
